export default "__VITE_ASSET__CEfn6mUz__"